/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react-hooks/exhaustive-deps */
import React, {useState, useCallback, memo, useRef, useLayoutEffect, useEffect} from 'react';
import {
  TableDefault,
  TableAverage,
  ShadowTableColumn,
  ShadowTableHead,
  ShadowSummaryColumn,
  StickyMainHeader,
  StickyShadowMainHeader,
  StickySubHeader,
  ChangeContainer,
  ArrowDownContainer,
  ArrowHolderSummary,
  ColumnContainerSummary,
  LoadSpace,
  FeatureLocked,
  TitleFeatureLocked,
  TextFeatureLocked,
} from './styles';
import {SelectPlayerColumn} from '..';
import {GoArrowDown, GoChevronDown, GoChevronUp} from 'react-icons/go';
import numberColumnFormatter from '../../utils/hooks/number-column-formatter';
import getFatigueZoneBullet from '../../utils/hooks/fatigue-zone-bullet';
import {Popover} from '../popOver/Popover';
import HideOn from '../../assets/icons/HideOn.png';
import HideOff from '../../assets/icons/HideOff.png';
import Loader from '../loader/loader';
import {Utils} from '../../utils/api';
interface TableFreshROMProps {
  dataTableContent: Array<any>;
  dataAverage: object | any;
  minWidth: string;
  filter: string;
  dataCy?: string;
  fatigueZone?: boolean;
  hidePlayer?: any;
  sortBy: string;
  sortOrder: string;
  handleSort: (column: string) => void;
}

const TableItem = memo(({item, fatigueZone, changeStatus, hidePlayer}: any) => {
  const [hide, setHide] = useState(() => item.excludeFromExamAvg);
  const [opacity, setOpacity] = useState(() => (item.excludeFromExamAvg ? '0.5' : '1'));
  const [left, setLeft] = useState<number>(479);
  const dateRef = useRef(0) as any;
  const hiddenRef = useRef(0) as any;
  const PlayerRef = useRef(0) as any;

  useLayoutEffect(() => {
    changeScreen();
  }, []);

  useEffect(() => {
    window.addEventListener('resize', changeScreen);

    return () => {
      window.removeEventListener('resize', changeScreen);
    };
  }, []);

  const changeScreen = () => {
    /** 19px is added to maintain component margin */
    setLeft(hiddenRef.current.offsetWidth + PlayerRef.current.offsetWidth + dateRef.current.offsetWidth + 19);
  };

  const handleHideToggle = useCallback(() => {
    setHide(prevHide => {
      const newHideState = !prevHide;
      setOpacity(newHideState ? '0.5' : '1');
      hidePlayer(item._id, newHideState ? 'exclude' : 'include');
      return newHideState;
    });
  }, [item._id, hidePlayer]);

  return (
    <tr style={{opacity, position: 'relative'}}>
      <td className="white pointer" onClick={handleHideToggle} ref={hiddenRef}>
        {hide ? <img src={HideOn} alt="hideOn" /> : <img src={HideOff} alt="hideOff" />}
      </td>
      <SelectPlayerColumn PlayerColumnRef={PlayerRef} unClickeable={item.plan === 'basic'} player={item} padding={'8px'} />
      <ShadowTableColumn ref={dateRef}>
        {(item.summary.createdAt && new Date(item.summary.createdAt).toLocaleDateString('en-US')) || '-'}
      </ShadowTableColumn>
      <td className="white">
        {item.plan !== 'basic' && numberColumnFormatter(item.summary.romTotalLast, {digits: 0})}
        {item.plan !== 'basic' && fatigueZone && getFatigueZoneBullet(item?.summary?.romTotalArcStatus)}
      </td>
      <td className="white">{item.plan !== 'basic' && numberColumnFormatter(item.summary.romTotalArcAvg, {digits: 0})}</td>
      <td className="white">
        <ChangeContainer>
          <span>{item.plan !== 'basic' && numberColumnFormatter(item.summary.totalARCTrend, {digits: 0})}</span>
          {item.plan !== 'basic' && changeStatus(item.summary.totalARCTrend)}
        </ChangeContainer>
      </td>
      <ShadowTableColumn>
        {item.plan !== 'basic' && numberColumnFormatter(item.summary.romInternalRotationLast, {digits: 0})}
        {item.plan !== 'basic' && fatigueZone && getFatigueZoneBullet(item?.summary?.romInternalRotationStatus)}
      </ShadowTableColumn>
      <ShadowTableColumn>
        {item.plan !== 'basic' && numberColumnFormatter(item.summary.romInternalRotationAvg, {digits: 0})}
      </ShadowTableColumn>
      <ShadowTableColumn>
        <ChangeContainer>
          <span>{item.plan !== 'basic' && numberColumnFormatter(item.summary.romIRTrend, {digits: 0})}</span>
          {item.plan !== 'basic' && changeStatus(item.summary.romIRTrend)}
        </ChangeContainer>
      </ShadowTableColumn>
      <td className="white">
        {item.plan !== 'basic' && numberColumnFormatter(item.summary.romExternalRotationLast, {digits: 0})}
        {item.plan !== 'basic' && fatigueZone && getFatigueZoneBullet(item?.summary?.romExternalRotationStatus)}
      </td>
      <td className="white">{numberColumnFormatter(item.summary.romExternalRotationAvg, {digits: 0})}</td>
      <td className="white">
        <ChangeContainer>
          <span>{item.plan !== 'basic' && numberColumnFormatter(item.summary.romERTrend, {digits: 0})}</span>
          {item.plan !== 'basic' && changeStatus(item.summary.romERTrend)}
        </ChangeContainer>
      </td>
      <ShadowTableColumn>
        {item.plan !== 'basic' &&
          (item.summary.shoulderFlexionThrowDegrees ||
            item.summary.shoulderFlexionValue ||
            numberColumnFormatter(item.summary.shoulderFlexionThrowDegrees, {digits: 0}))}
      </ShadowTableColumn>
      <ShadowTableColumn>
        {item.plan !== 'basic' &&
          (item.summary.shoulderFlexionThrowDegrees !== null
            ? numberColumnFormatter(item.summary.shoulderFlexionThrowAverage, {digits: 0})
            : '-')}
      </ShadowTableColumn>
      <ShadowTableColumn>
        <span>{item.plan !== 'basic' && numberColumnFormatter(item.summary.shoulderFlexionThrowChange, {digits: 0})}</span>
        {item.plan !== 'basic' && changeStatus(item.summary.shoulderFlexionThrowChange)}
      </ShadowTableColumn>
      {item.plan === 'basic' && (
        <FeatureLocked left={left} right={19}>
          <TitleFeatureLocked>
            Basic Subscription
            <TextFeatureLocked>
              {' '}
              - Unlock this data by sponsoring the athlete or have the player purchase a premium subscription
            </TextFeatureLocked>
          </TitleFeatureLocked>
        </FeatureLocked>
      )}
    </tr>
  );
});

const TableFreshROM = memo(
  ({
    dataTableContent,
    dataAverage,
    filter,
    minWidth,
    dataCy,
    fatigueZone,
    hidePlayer,
    sortBy,
    sortOrder,
    handleSort,
  }: TableFreshROMProps) => {
    const [popUp, setPopUp] = useState<string>('');
    const [table, useTable] = useState<Array<any>>(dataTableContent);
    const [loading, useLoading] = useState<boolean>(false);
    const [reverse, useReverse] = useState<boolean>(false);
    const [sort, useSort] = useState<string>('');
    const UTILS = new Utils();

    const togglePopUp = useCallback((selectedPopUp: string) => {
      setPopUp(prev => (prev === selectedPopUp ? '' : selectedPopUp));
    }, []);

    useEffect(() => {
      useLoading(false);
    }, [dataTableContent]);

    const changeStatus = useCallback(change => {
      // Downward arrows hidden per requirements - logic preserved
      // if (Math.trunc(change) < 0) {
      //   return (
      //     <ArrowDownContainer>
      //       <GoArrowDown size="10px" color="#fff" />
      //     </ArrowDownContainer>
      //   );
      // }
      return null;
    }, []);

    function sortFlexion(sort, params) {
      useSort(sort);
      useReverse(!reverse);
      UTILS.SortStringsAndNumbers(params, [!reverse, changeTable, table]);
    }

    const memoizedHidePlayer = useCallback(hidePlayer, [hidePlayer]);

    const changeTable = useCallback(
      (table: any) => {
        useTable([...table]);
      },
      [useTable],
    );

    return (
      <TableDefault data-cy={dataCy} minWidth={minWidth}>
        <thead>
          <tr>
            <StickyMainHeader>HIDE</StickyMainHeader>
            <StickyMainHeader onClick={() => handleSort('playerName')} style={{cursor: 'pointer'}}>
              PLAYERS {sortBy === 'playerName' && (sortOrder === 'asc' ? '▲' : '▼')}
            </StickyMainHeader>
            <StickyShadowMainHeader onClick={() => handleSort('date')} style={{cursor: 'pointer'}}>
              DATE {sortBy === 'date' && (sortOrder === 'asc' ? '▲' : '▼')}
            </StickyShadowMainHeader>
            <StickyMainHeader colSpan={3}>TOTAL ARC</StickyMainHeader>
            <StickyShadowMainHeader colSpan={3}>INTERNAL ROTATION</StickyShadowMainHeader>
            <StickyMainHeader colSpan={3}>EXTERNAL ROTATION</StickyMainHeader>
            <StickyShadowMainHeader colSpan={3}>FLEXION</StickyShadowMainHeader>
          </tr>
          <tr>
            <StickySubHeader />
            <StickySubHeader onClick={() => handleSort('playerName')}>
              <ColumnContainerSummary>
                <span>Sort Name</span>
                <ArrowHolderSummary>
                  {sortBy === 'playerName' && sortOrder === 'asc' && <GoChevronDown size={14} />}
                  {sortBy === 'playerName' && sortOrder === 'desc' && <GoChevronUp size={14} />}
                </ArrowHolderSummary>
              </ColumnContainerSummary>
            </StickySubHeader>
            <ShadowTableHead onClick={() => handleSort('date')}>
              <ColumnContainerSummary>
                <span>Sort Date</span>
                <ArrowHolderSummary>
                  {sortBy === 'date' && sortOrder === 'asc' && <GoChevronDown size={14} />}
                  {sortBy === 'date' && sortOrder === 'desc' && <GoChevronUp size={14} />}
                </ArrowHolderSummary>
              </ColumnContainerSummary>
            </ShadowTableHead>
            <StickySubHeader>
              <span onClick={() => togglePopUp('pu_1')}>Current</span>
              <Popover
                table={dataTableContent}
                data={['summary', 'romTotalLast']}
                popup_id={'pu_1'}
                visible={popUp}
                useTable={changeTable}
              />
            </StickySubHeader>
            <StickySubHeader>
              <span onClick={() => togglePopUp('pu_2')}>Avg</span>
              <Popover
                table={dataTableContent}
                data={['summary', 'romTotalArcAvg']}
                popup_id={'pu_2'}
                visible={popUp}
                useTable={changeTable}
              />
            </StickySubHeader>
            <StickySubHeader>
              <span onClick={() => togglePopUp('pu_3')}>Change</span>
              <Popover
                table={dataTableContent}
                data={['summary', 'totalARCTrend']}
                popup_id={'pu_3'}
                visible={popUp}
                useTable={changeTable}
              />
            </StickySubHeader>
            <ShadowTableHead>
              <span onClick={() => togglePopUp('pu_4')}>Current</span>
              <Popover
                table={dataTableContent}
                data={['summary', 'romInternalRotationLast']}
                popup_id={'pu_4'}
                visible={popUp}
                useTable={changeTable}
              />
            </ShadowTableHead>
            <ShadowTableHead>
              <span onClick={() => togglePopUp('pu_5')}>Avg</span>
              <Popover
                table={dataTableContent}
                data={['summary', 'romInternalRotationAvg']}
                popup_id={'pu_5'}
                visible={popUp}
                useTable={changeTable}
              />
            </ShadowTableHead>
            <ShadowTableHead>
              <span onClick={() => togglePopUp('pu_6')}>Change</span>
              <Popover
                table={dataTableContent}
                data={['summary', 'romIRTrend']}
                popup_id={'pu_6'}
                visible={popUp}
                useTable={changeTable}
              />
            </ShadowTableHead>
            <StickySubHeader>
              <span onClick={() => togglePopUp('pu_7')}>Current</span>
              <Popover
                table={dataTableContent}
                data={['summary', 'romExternalRotationLast']}
                popup_id={'pu_7'}
                visible={popUp}
                useTable={changeTable}
              />
            </StickySubHeader>
            <StickySubHeader>
              <span onClick={() => togglePopUp('pu_8')}>Avg</span>
              <Popover
                table={dataTableContent}
                data={['summary', 'romExternalRotationAvg']}
                popup_id={'pu_8'}
                visible={popUp}
                useTable={changeTable}
              />
            </StickySubHeader>
            <StickySubHeader>
              <span onClick={() => togglePopUp('pu_9')}>Change</span>
              <Popover
                table={dataTableContent}
                data={['summary', 'romERTrend']}
                popup_id={'pu_9'}
                visible={popUp}
                useTable={changeTable}
              />
            </StickySubHeader>
            <ShadowTableHead onClick={() => sortFlexion('sortflexionCurrent', ['summary', 'shoulderFlexionThrowDegrees'])}>
              <ColumnContainerSummary>
                <span>Current</span>
                <ArrowHolderSummary>
                  {sortBy === 'sortflexionCurrent' && sortOrder === 'asc' && <GoChevronDown size={14} />}
                  {sortBy === 'sortflexionCurrent' && sortOrder === 'desc' && <GoChevronUp size={14} />}
                </ArrowHolderSummary>
              </ColumnContainerSummary>
            </ShadowTableHead>
            <ShadowTableHead onClick={() => sortFlexion('sortflexionAvg', ['summary', 'shoulderFlexionThrowAverage'])}>
              <ColumnContainerSummary>
                <span>Avg</span>
                <ArrowHolderSummary>
                  {sortBy === 'sortflexionAvg' && sortOrder === 'asc' && <GoChevronDown size={14} />}
                  {sortBy === 'sortflexionAvg' && sortOrder === 'desc' && <GoChevronUp size={14} />}
                </ArrowHolderSummary>
              </ColumnContainerSummary>
            </ShadowTableHead>
            <ShadowTableHead onClick={() => sortFlexion('sortflexionChg', ['summary', 'shoulderFlexionThrowChange'])}>
              <ColumnContainerSummary>
                <span>Change</span>
                <ArrowHolderSummary>
                  {sortBy === 'sortflexionChg' && sortOrder === 'asc' && <GoChevronDown size={14} />}
                  {sortBy === 'sortflexionChg' && sortOrder === 'desc' && <GoChevronUp size={14} />}
                </ArrowHolderSummary>
              </ColumnContainerSummary>
            </ShadowTableHead>
          </tr>
        </thead>
        <tbody>
          {dataTableContent.length > 0 && (
            <tr className="tr-average">
              <td style={{borderLeft: '7px solid var(--PrimaryBlue)'}} />
              <td>
                <TableAverage>
                  <LoadSpace>{loading && <Loader width="20px" color="#B1D6FF" />}</LoadSpace>
                  Team Average:
                </TableAverage>
              </td>
              <ShadowSummaryColumn></ShadowSummaryColumn>
              <td>{numberColumnFormatter(dataAverage.totalARC, {digits: 0})}</td>
              <td>{numberColumnFormatter(dataAverage.totalARCAvg, {digits: 0})}</td>
              <td>
                <ChangeContainer>
                  <span> {numberColumnFormatter(dataAverage.totalARCTrend, {digits: 0})}</span>
                  {changeStatus(dataAverage.totalARCTrend)}
                </ChangeContainer>
              </td>
              <ShadowSummaryColumn>{numberColumnFormatter(dataAverage.romIR, {digits: 0})}</ShadowSummaryColumn>
              <ShadowSummaryColumn>{numberColumnFormatter(dataAverage.romIRAvg, {digits: 0})}</ShadowSummaryColumn>
              <ShadowSummaryColumn>
                <ChangeContainer>
                  <span>{numberColumnFormatter(dataAverage.romIRTrend, {digits: 0})}</span>
                  {changeStatus(dataAverage.romIRTrend)}
                </ChangeContainer>
              </ShadowSummaryColumn>
              <td>{numberColumnFormatter(dataAverage.romER, {digits: 0})}</td>
              <td>{numberColumnFormatter(dataAverage.romERAvg, {digits: 0})}</td>
              <td>
                <ChangeContainer>
                  <span>{numberColumnFormatter(dataAverage.romERTrend, {digits: 0})}</span>
                  {changeStatus(dataAverage.romERTrend)}
                </ChangeContainer>
              </td>
              <ShadowSummaryColumn>{numberColumnFormatter(dataAverage.shoulderFlexionThrowDegrees, {digits: 0})}</ShadowSummaryColumn>
              <ShadowSummaryColumn>{numberColumnFormatter(dataAverage.shoulderFlexionThrowAverage, {digits: 0})}</ShadowSummaryColumn>
              <ShadowSummaryColumn>{numberColumnFormatter(dataAverage.shoulderFlexionThrowChange, {digits: 0})}</ShadowSummaryColumn>
            </tr>
          )}

          {dataTableContent.length > 0 ? (
            dataTableContent
              .filter(el => {
                const playerName: string = el?.firstName || '';
                const playerLast: string = el?.lastName || '';
                const name = `${playerName} ${playerLast}`;
                return name.toLocaleLowerCase().includes(filter.toLowerCase());
              })
              .map((item, index) => {
                item.summary.alerts = item.summary.alerts?.filter(alert => {
                  if (alert === 'Pain') return true;
                  else return false;
                });
                return (
                  <TableItem
                    key={item._id}
                    item={item}
                    fatigueZone={fatigueZone}
                    changeStatus={changeStatus}
                    hidePlayer={memoizedHidePlayer}
                  />
                );
              })
          ) : (
            <tr>
              <td colSpan={25}>No Data</td>
            </tr>
          )}
        </tbody>
      </TableDefault>
    );
  },
);

export default TableFreshROM;
